module.exports = __webpack_public_path__ + "static/greenstone-logo-cd8a9f1c5e05081a7f4b644e82bcdc4e.png";